$(document).ready(function () {

    var sidebar = $("#viewport-sidebar");
    sidebar.on('click', ".task a.tasks-complete", function (e) {
        e.stopPropagation();

        if ($(this).closest('.task').hasClass('complete')) {
            return false;
        }

        $('<div id="dialog-tasks-complete" title="Задача выполнена"></div>').dialog({
            open: function() {
                $('#dialog-tasks-complete').progressbar({ value: false });

                $.get($(e.target).attr('href'), function (data) {
                    $('#dialog-tasks-complete').progressbar("destroy").html(data);
                    makeRadiosCheckboxesAndSelectsBeautiful();
                });
            },
            close: function() {
                $('#dialog-tasks-complete').remove();
            },
            modal: true,
            width: 500,
            height: 320,
            buttons: [
                {
                    text: "Сохранить",
                    type: "submit",
                    icons: {
                        primary: "ui-icon-disk"
                    },
                    click: function() {
                        $(".ui-dialog-buttonpane button").button("disable");

                        var $this = $(this);

                        $.ajax({
                            url: $this.find("form").attr('action'),
                            type: "POST",
                            data: $this.find("form").serialize(),
                            error: function(XMLHttpRequest, textStatus, errorThrown)  {
                                alert("При отправке формы произошла ошибка: " + errorThrown)
                            },
                            success: function(data){
                                $this.dialog("close");

                                $(e.target).closest('.task').addClass('complete');

                                var currentDate = $('#calendar td.date-current');

                                $(currentDate).removeClass('date-current').trigger('click');

                                $.get(Routing.generate('tasks') + '?calendar=' + $('#calendar').data('year-month'), function (data) {
                                    $('#calendar').replaceWith($('#calendar', data));

                                    calendarButtonsWidth();
                                });

                            },
                            complete: function() {
                                $(".ui-dialog-buttonpane button").button("enable");
                            }
                        });
                    }
                },
                {
                    text: "Закрыть",
                    icons: {
                        primary: "ui-icon-close"
                    },
                    click: function() {
                        $(this).dialog( "close" );
                    }
                }
            ]
        });

        e.preventDefault();
    });

});
